var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!./scripts/step-up-answer-edit.js"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler?id=data-v-16f7896c!../../node_modules/vue-loader/lib/template-loader?raw&engine=pug!./templates/step-up-answer-edit.pug"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/StepUpAnswerEdit.vue
// module id = 1348
// module chunks = 1